import React from 'react';

const CreateResumeSuccessHeader = ({ title, content }) => {
  const successImage = `${process.env.REACT_APP_ASSETS_URL}/Career/img-career-success.svg`;

  return (
    <div className='w-full flex flex-col items-center tabletH:px-[40px] tabletH:pt-[60px]'>
      <div className='flex flex-col items-center pb-[22px] tabletH:pb-[30px]'>
        <img alt='successImage' src={successImage} />
        <div className='flex flex-col items-center gap-1 text-text-primary'>
          <div className='typo-title3 tabletH:typo-h7'>{title}</div>
          <div className='flex flex-col items-center text-center typo-b12 tabletH:typo-b16'>
            {content}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateResumeSuccessHeader;
